
module.exports = function getResource(label) {
    const resources = {
        outOfStock: 'En cas de rupture de stock :',
        notSubstitute: 'Ne pas remplacer',
        substituteWith: 'Remplacer par...',
        substitutionInfoTitle: 'About Item Substitution'
    };

    return resources[label];
};
